module.exports = __webpack_public_path__ + "img/circles.32cb4fe1.svg";